import logo from '@/assets/Logo.svg';
import { cn } from '@/utils/cn';

import { Link } from '../ui/link';

type LogoProps = {
  className?: string;
  onClick?: () => void;
};

export const Logo = ({ className, onClick }: LogoProps) => {
  return (
    <Link
      className={cn('flex flex-none items-center', className)}
      to="/"
      aria-label="Brand"
      onClick={onClick}
    >
      <img className="h-8 w-auto" src={logo} alt="SCL Logo" />
    </Link>
  );
};
